export enum GenderEnum {
  Male = 0,
  Female,
}
